import { User } from '~/app/shared/types/user/user.type';

import { isProfileComplete } from './is-profile-complete';

/**
 * Règle de priorité (EF-3852) : la popin de saisie s'ouvre au login uniquement si le profil est
 * incomplet, que l'utilisateur n'a pas coché « ne plus afficher », et hors contexte tutoriel/démo.
 * Le membre passé DOIT être fraîchement récupéré (`GET /members/me`) — cf. `isProfileComplete`.
 */
export const shouldOpenProfileIncompletePopin = (params: {
    user: User | undefined,
    hidePopin: boolean,
    hasTutorial: boolean,
}): boolean => !params.hidePopin && !params.hasTutorial && !isProfileComplete(params.user);
